const LOG_PREFIX = 'script-supplier:';

export const logWarning = (message, ...rest) => {
  console.warn(`${LOG_PREFIX} ${message}`, ...rest);
};

export const logError = (message, ...rest) => {
  console.error(`${LOG_PREFIX} ${message}`, ...rest);
};
